var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionCopyText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.751,
    height: 17.203,
    viewBox: "0 0 13.751 17.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9743",
    "data-name": "Group 9743",
    transform: "translate(-26.733 -1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M11801.857,5586.419h-1.25v-1h1.25a.5.5,0,0,0,.5-.5v-12a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5v.705h-1v-.705a1.5,1.5,0,0,1,1.5-1.5h8a1.5,1.5,0,0,1,1.5,1.5v12A1.5,1.5,0,0,1,11801.857,5586.419Z",
    transform: "translate(-11762.875 -5569.602)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_13847",
    "data-name": "Path 13847",
    transform: "translate(26.733 4.02)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0h8A1.5,1.5,0,0,1,11,1.5v12A1.5,1.5,0,0,1,9.5,15h-8A1.5,1.5,0,0,1,0,13.5V1.5A1.5,1.5,0,0,1,1.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 1 C 1.224300384521484 1 1 1.224300384521484 1 1.5 L 1 13.5 C 1 13.77569961547852 1.224300384521484 14 1.5 14 L 9.5 14 C 9.775699615478516 14 10 13.77569961547852 10 13.5 L 10 1.5 C 10 1.224300384521484 9.775699615478516 1 9.5 1 L 1.5 1 M 1.5 0 L 9.5 0 C 10.32843017578125 0 11 0.67156982421875 11 1.5 L 11 13.5 C 11 14.32843017578125 10.32843017578125 15 9.5 15 L 1.5 15 C 0.67156982421875 15 0 14.32843017578125 0 13.5 L 0 1.5 C 0 0.67156982421875 0.67156982421875 0 1.5 0 Z",
    stroke: "none",
    fill: "#4d4d4d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCopyText);
export default __webpack_public_path__ + "static/media/action_copy_text.7974b3659127df83019aa9e58cc97126.svg";
export { ForwardRef as ReactComponent };